import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styles from './FormField.scss';
import classNames from 'classnames';

export default class FormField extends Component {
    static propTypes = {
        label: PropTypes.string,
        labelNote: PropTypes.string,
        className: PropTypes.string,
        error: PropTypes.string,
    };

    render() {
        const {
            label,
            labelNote,
            className,
            error,
            children
        } = this.props;

        const fieldClassName = classNames(styles.formField, className);
        const withNote = labelNote && labelNote.length;
        const labelClassName = classNames(styles.label, {[styles.error]: error, [styles.withNote]: withNote});

        return (
            <div className={fieldClassName}>
                <label className={labelClassName}>{label}</label>
                {withNote &&
                <label className={styles.note}>{labelNote}</label>
                }
                {children}
                <div className={styles.errorLabel}>{error}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/controls/form/FormField.jsx